import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-run-my-numbers',
  templateUrl: './run-my-numbers.component.html',
  styleUrls: ['./run-my-numbers.component.scss']
})
export class RunMyNumbersComponent implements OnInit {

  loanType:number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
